import React from "react"
import ProductModelBase from "theme/base/shop/ProductModel"
import { Icon } from "semantic-ui-react"
import shop from "shop/shop"

export default class ProductModel extends ProductModelBase {
  
  constructor( data ) {
    super( data );
    this.isSale = data.pinfos && !!data.pinfos.rabatt
    
    if ( this.cats && this.cats.length > 0 ) {
      let sortedCategories = this.cats && this.cats.sort( ( c0, c1 ) => {
        let a = c0.cat_id
        let b = c1.cat_id
        if ( a.length > b.length ) return -1
        if ( a.length < b.length ) return 1
        return a > b ? -1 : 1
      } )
      const cat_id = sortedCategories[ 0 ].cat_id
      this.category = shop.categoriesById.get( cat_id )
      if ( !this.category ) {
        console.error( "No Category found:", this.map_id, { cat_id } )
        this.category = {}
      }
    }
    
    this.canBeBought = true
  }
  
  getNotice = ( size ) => {
    const notice = <AvailabilityNotice size={size} product={this}/>
    return notice
  }
}


function AvailabilityNotice( { product, size } ) {
  let text = product.stock > 0 ? translate("Auf Lager") : translate("in Kürze lieferbar")
  let color = product.stock > 0 ? "green" : "yellow"
  let productInCart = null;
  if (product.stock > 0 && shop.cart && shop.cart.data && shop.cart.data.positions) {
    productInCart = shop.cart.data.positions.find(position => position.article_id === product.map_id);
    if(productInCart != null){
      //console.log("productInCart",productInCart.count, product.stock, product.map_id)
      if(productInCart.count > product.stock){
        text = "Teillieferung"
        return <div className={"Availability"}>
        <span className={""}><Icon title={text} name="truck" color={color}/><Icon title={text} name="truck" color={"orange"}/> {text}</span>
      </div>
      }
    }
  }
  
  
  if ( size === "tiny" ) {
    return <div className={"Availability"}>
      <span className={""}><Icon title={text} name="truck" color={color}/> {text}</span>
    </div>
  }
  
  return <div className={"Availability"}>
    <span className={""}><Icon title={text} name="truck" color={color}/> {text}</span>
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/hvz/shop/ProductModel.js